import React, { useEffect, useState } from 'react';
import './EbookPage.scss';
import { Helmet } from 'react-helmet-async';
import { baseStrapiURL, baseURL } from '../../services/config';
import { useContentQuery } from '../../services/strapi/hooks';
import Loading from '../../components/Loading/Loading';
import { useQueryClient } from '@tanstack/react-query';
import Error404Page from '../Error404Page/Error404Page';
import Header from './components/Header/Header';
import Goals from './components/Goals/Goals';
import About from './components/About/About';

export default function EbookPage({setEbookModalContent, setShowEbookModal}) {

    const strapiPage = 'ebook';

    const queryClient = useQueryClient();

    // Utilisation du hook personnalisé pour récupérer les données
    const { data: strapiData, isLoading, error } = useContentQuery(strapiPage);

    // Obtenir les données mises en cache ou les données actuelles
    const displayData = strapiData || queryClient.getQueryData(['strapi-content', strapiPage]);

    // N'afficher le chargement que si les données ne sont pas disponibles
    const showLoading = isLoading && !displayData;

    useEffect(() => {
        window.scroll(0, 0);
        if (displayData) {
            setEbookModalContent({
                Remerciements: displayData.Remerciements,
                Ebook: displayData.Ebook,
            })
        }
    }, [displayData]);


    if (showLoading) return <Loading />;
    if (!displayData || displayData.length === 0 || error) return <Error404Page />;

    return (
        <div className="ebook-page">
            <Helmet>
                {/* Open Graph (utilisé par Facebook, LinkedIn, etc.) */}
                <meta property="og:title" content={displayData.SEO.TitreOnglet} />
                <meta property="og:description" content={displayData.SEO.Description} />
                <meta property="og:image" content={baseStrapiURL + displayData.SEO.PhotoReseauxSociaux_1200x630.url} />
                <meta property="og:url" content={displayData.Slug === null ? baseURL : baseURL + '/' + displayData.Slug} />
                <meta property="og:type" content="website" />

                {/* Twitter Cards */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={displayData.SEO.TitreOnglet} />
                <meta name="twitter:description" content={displayData.SEO.Description} />
                <meta name="twitter:image" content={baseStrapiURL + displayData.SEO.PhotoReseauxSociaux_1200x630.url} />
                <meta name="twitter:url" content={displayData.Slug === null ? baseURL : baseURL + '/' + displayData.Slug} />

                <title>{displayData.SEO.TitreOnglet}</title>
                <meta name="description" content={displayData.SEO.Description} />
                <link
                    rel="preload"
                    as="image"
                    href="/assets/ebook/background.jpg"
                    fetchPriority="high"
                />
                <link
                    rel="preload"
                    as="image"
                    href="/assets/ebook/background.webp"
                    fetchPriority="high"
                />
            </Helmet>
            <div className="ebook-page__content">
                <Header strapiData={displayData.EnTete} setShowEbookModal={setShowEbookModal} />
                <Goals strapiData={displayData.ObjectifsPart} setShowEbookModal={setShowEbookModal} />
                <About strapiData={displayData.Moi} />
            </div>
        </div>
    );
}